import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
	selector: 'app-validation-message',
	templateUrl: './validation-message.component.html',
})
export class ValidationMessageComponent {
	@Input() errors: ValidationErrors;
	/** What the field measures in mm, e.g. 'De breedte': its range errors then name it. */
	@Input() measure?: string;

	public mm(value: unknown): number {
		return Math.round(Number(value));
	}
}
